<template>
  <div class="pin-code">
    <input
      type="number"
      class="desktop-only"
      v-model="code"
      @focus="focusHandler()"
      @blur="blurHandler()"
      @keyup="updateTemp($event)"
      @keydown="checkCodeLength($event)"
    />
    <div @click="clickHandler()" class="fake-input mobile-only"></div>
    <div
      class="pin-code__box"
      v-bind:class="{ focused: inputFocus && code.length === 0 }"
    >
      {{ code.charAt(0) }}
    </div>

    <div
      v-bind:key="n"
      v-for="n in 5"
      class="pin-code__box"
      v-bind:class="{ focused: code.length === n }"
    >
      {{ code.charAt(n) }}
    </div>
  </div>
</template>

<script>
import LoginService from "@/services/LoginService";
export default {
  name: "verifyCode",
  data() {
    return {
      code: "",
      inputFocus: false
    };
  },
  mounted() {
    this.$root.$on("onNumericPadKeyPressed", this.onNumericPadKeyPressed);
    // this.autoFocusOnMobile();
  },
  methods: {
    focusHandler() {
      this.inputFocus = true;
    },
    clickHandler() {
      this.inputFocus = true;
      // This timeout will delay the "open" event of the numeric pad
      // so that would be executed right *after* the click event,
      // which - otherwise - would also close it immediately
      setTimeout(() => {
        this.$root.$emit("openNumericPad");
      }, 10);
    },
    blurHandler() {
      this.inputFocus = false;
    },
    onNumericPadKeyPressed(key) {
      if (key === "X") {
        this.code = this.code.slice(0, -1);
        this.updateTemp({ key: "Backspace" });
      } else {
        if (!this.maxDigitsReached()) {
          this.code += key;
          this.updateTemp({ key: key + "" });
        }
      }
    },
    updateTemp() {
      this.$emit("onUpdate", this.code);
    },
    checkCodeLength(event) {
      if (this.maxDigitsReached() && event.key !== "Backspace") {
        event.preventDefault();
        return;
      }
    },
    maxDigitsReached() {
      const maxDigits = 6;
      return this.code.length >= maxDigits;
    },
    autoFocusOnMobile() {
      setTimeout(() => {
        if (
          LoginService.getFromApp() === true ||
          this.$store.state.detect.platform.type === "mobile"
        ) {
          this.$root.$emit("openNumericPad");
        }
      }, 300);
    }
  }
};
</script>

<style scoped lang="less">
.pin-code {
  display: flex;
  position: relative;
  justify-content: space-between;
  max-width: 350px;
  margin: 0 auto;
  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .fake-input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  &__box {
    width: 45px;
    height: 45px;
    font-size: 25px;
    border: 1px solid #eaeaea;
    padding: 5px 10px 0 10px;
    text-align: center;
    border-radius: 5px;
    &.focused {
      border: 1px solid #000000;
    }
  }
}
</style>
